import { Protocol } from "../../Protocol";

export class TransferOrderGroupProtocol {

  public static readonly GET_TRANSFER_ORDER_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/transformgroups/all`; // 取得轉單群組清單
  public static readonly GET_PAGEABLE_TRANSFER_ORDER_GROUPS: string = `${Protocol.YATUNG_API_ROOT}/users/transformgroups/pageable`; // 取得分頁轉單群組清單
  public static readonly TRANSFER_ORDER_GROUP_URL: string = `${Protocol.YATUNG_API_ROOT}/users/transformgroups`; // 轉單群組清單通用url

}